import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import RippleButton from "../../../components/common/RippleButton";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { LoadingPanel } from "../../../components/layout/Loading";
import {
  clearActiveStep,
  clearQuotationInformation,
  decreaseActiveStep,
} from "../quotationSlice";
import { closeDialog } from "../../../components/dialog/dialogSlice";
import ShadowCard from "../../../components/common/ShadowCard";
import { getAllActiveItinerary } from "../../itinerary/services/itineary.services";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { getAllActiveItineraryFacility } from "../../ItineraryFacility/services/itineraryfacility.services";
import {
  createQuotationStep2,
  getQuotationByID,
} from "../services/quotation.services";
import TourItineraryArray from "./TourItineraryArray";
import { getCityBySectorID } from "../../city/services/city.services";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const TourItineararyChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const QuotationDetail = useAppSelector(
    (state) => state.quotation.QuotationDetail
  );

  useEffect(() => {
    const tourItineraryCopy =
      QuotationDetail?.TourItinerary &&
      QuotationDetail?.TourItinerary?.length > 0
        ? JSON.parse(JSON.stringify(QuotationDetail?.TourItinerary))?.map(
            (tourItinerary: any) => ({
              ...tourItinerary,
            })
          )
        : [];
    formRenderProps.onChange("TourItinerary", {
      value: tourItineraryCopy || [],
    });
  }, [QuotationDetail]);
  return null;
};
const TourItinerary: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const QuotationID = location.state?.QuotationID;
  const SectorID = location.state?.SectorID;
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.quotation.loading);
  const QuotationDetail = useAppSelector(
    (state) => state.quotation.QuotationDetail
  );

  useEffect(() => {
    dispatch(getAllActiveItinerary());
    dispatch(getAllActiveItineraryFacility());

    return () => {
      dispatch(closeDialog());
      dispatch(clearQuotationInformation());
    };
  }, []);

  useEffect(() => {
    if (QuotationID) {
      dispatch(getQuotationByID({ ID: +QuotationID }));
    }
  }, [QuotationID]);

  useEffect(() => {
    if (SectorID) {
      dispatch(getCityBySectorID(SectorID));
    }
  }, [SectorID]);

  const handleSubmit = async (values: any) => {
    if (QuotationID) {
      const insertPayload = [
        ...(values.TourItinerary
          ? values.TourItinerary.map((touritinerary: any) => {
              return {
                DayNo: touritinerary.DayNo ? touritinerary.DayNo : "",
                QuotationID: QuotationID,
                ItinaryID: touritinerary.ItinaryID
                  ? touritinerary.ItinaryID
                  : null,
                Description: touritinerary.Description
                  ? touritinerary.Description
                  : "",
                PlaceID: touritinerary.PlaceID ? +touritinerary.PlaceID : null,
                Facilty: Array.isArray(touritinerary?.Facilty)
                  ? touritinerary?.Facilty.join(",")
                  : touritinerary?.Facilty || "",
              };
            })
          : []),
      ];

      const response = await dispatch(createQuotationStep2(insertPayload));

      if (response?.meta?.requestStatus === "fulfilled") {
        dispatch(clearActiveStep());
        if (location.state?.mode === "create") {
          navigate("/quotation");
        } else {
          navigate(-1);
        }
      }
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        initialValues={QuotationDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <TourItineararyChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem style={{ marginTop: 10 }} colSpan={3}>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={TourItineraryArray}
                    name="TourItinerary"
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  <RippleButton
                    type="button"
                    fillMode="outline"
                    themeColor="primary"
                    style={{ marginRight: 10 }}
                    onClick={() => dispatch(decreaseActiveStep())}
                  >
                    Previous
                  </RippleButton>
                  <ButtonWithLoading
                    label={"Save"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <RippleButton
                    fillMode="solid"
                    themeColor="primary"
                    style={{ marginLeft: 10 }}
                    onClick={() => navigate("/quotation")}
                  >
                    Go to Quotation List
                  </RippleButton>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};
export default TourItinerary;
